// API Endpoints
export const ENDPOINTS = {
  autocomplete: {
    tutors: "/api/admin/autocomplete/tutors",
    schools: "/api/admin/autocomplete/schools",
    groups: "/api/autocomplete/educatables",
  },
  calendar: {
    interviews: "/api/v2/admins/calendar/interviews",
    group_sessions: "/api/v2/admins/calendar/group_sessions",
    sessions: "/api/v2/admins/calendar/sessions",
  },
}

// Session Types
export const SESSION_TYPES = {
  GROUP_SESSIONS: "group_sessions",
  SESSIONS: "sessions",
  INTERVIEWS: "interviews",
}

export const SESSION_TYPES_LABELS = {
  GROUP_SESSIONS: "Schools",
  SESSIONS: "Family",
  INTERVIEWS: "Interviews",
}

// Calendar View Modes
export const VIEW_MODES = {
  WEEK: "week",
  MONTH: "month",
}

// Default Values
export const DEFAULTS = {
  SESSION_TYPE: "group_sessions",
  VIEW_MODE: VIEW_MODES.WEEK,
  DATE_FORMAT: "yyyy-MM-dd",
}

// URL Parameters
export const URL_PARAMS = {
  DATE: "date",
  TUTOR_ID: "tutor_id",
  SCHOOL_ID: "school_id",
  GROUP_ID: "group_id",
  TYPE: "type",
  VIEW: "view",
}

// Error Messages
export const ERROR_MESSAGES = {
  SCHOOL_REQUIRED: "School must be selected when filtering by Group",
  MONTH_VIEW_FILTER: "To view sessions by month, please select a tutor or school below",
  FETCH_CALENDAR_ERROR: "Failed to fetch calendar data",
  FETCH_INITIAL_VALUE_ERROR: "Failed to fetch initial value",
  FETCH_OPTIONS_ERROR: "Failed to fetch options",
}

// Calendar Dimensions
export const CALENDAR_DIMENSIONS = {
  DEFAULT_HEIGHT: "744px",
  MOBILE_ASPECT_RATIO: 0.5,
  DESKTOP_ASPECT_RATIO: 1.35,
}
